import { Component, HostListener } from '@angular/core';

@Component({
    selector: 'app-rule-of-thirds',
    templateUrl: './rule-of-thirds.component.html',
    styleUrls: ['./rule-of-thirds.component.css'],
})
export class RuleOfThirdsComponent {
    visible = false;

    @HostListener('document:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {
        if (event.key === '0') {
            this.visible = !this.visible;
        }
    }
}
